import Dropdown from '../../../components/dropdown/Dropdown';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Eye } from 'react-feather';

export function AdvancePagesList() {
  const history = useHistory();

  const advance_view_actions = [
    {
      label: 'Deposit Payments',
      onClick: () => history.push('/daily-fees/advance-payments'),
    },
    {
      label: 'Student Arrears',
      onClick: () => history.push('/daily-fees/student-arrears'),
    },
    {
      label: 'Arrears Payments',
      onClick: () => history.push('/daily-fees/arrears-payments'),
    },
  ];
  return (
    <Dropdown actions={advance_view_actions}>
      <button
        className="text-12 text-primary d-flex align-items-center font-bold pointer clean-btn "
        style={{ gap: '4px' }}
        onClick={() => {}}
      >
        <Eye size="14" strokeWidth="2px" />
        <span> OTHER PAGES</span>
      </button>
    </Dropdown>
  );
}
